import { render, staticRenderFns } from "./DateProductManufacturerModal.vue?vue&type=template&id=f046753c&scoped=true&"
import script from "./DateProductManufacturerModal.vue?vue&type=script&lang=js&"
export * from "./DateProductManufacturerModal.vue?vue&type=script&lang=js&"
import style0 from "./DateProductManufacturerModal.vue?vue&type=style&index=0&id=f046753c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f046753c",
  null
  
)

export default component.exports